// import { FinReportComponent } from './../../fin-report/fin-report.component';
import { CategoryDataService } from './../../../../services/category-data.service';
import { availableGroupings } from './../../asset-allocation/asset-allocation.component';
import { DoughnutChartItem } from './../../../shared/components/doughnut-chart/dought-item';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ViewChild,
} from '@angular/core';
import { groupBy } from 'underscore';
import { Investor } from '../../../shared/models/investor';
import { DoughnutChartjsComponent } from '../../../shared/components/doughnut-chartjs/doughnut-chartjs.component';

@Component({
  selector: 'app-breakdown',
  templateUrl: './breakdown.component.html',
  styleUrls: ['./breakdown.component.css'],
})
export class BreakdownComponent implements OnInit, OnChanges {

  constructor(private __categoryService: CategoryDataService) { }

  assetGroups = availableGroupings;
  chartData = [];
  // finReport
  @Input() once: boolean;
  @Output() onceChange = new EventEmitter();
  @Input() investor: Investor;
  @Input() category: string;
  @Input() new_risk_category: string;
  categoryData: Object;
  @Output() categoryChange = new EventEmitter();
  @Output() new_risk_categoryChange = new EventEmitter();


  @ViewChild('chart1')
  chart1: DoughnutChartjsComponent;
  @ViewChild('chart2')
  chart2: DoughnutChartjsComponent;
  @ViewChild('chart3')
  chart3: DoughnutChartjsComponent;
  @ViewChild('chart4')
  chart4: DoughnutChartjsComponent;

  second_chart: Array<DoughnutChartItem>
  third_chart: Array<DoughnutChartItem>
  fourth_chart: Array<DoughnutChartItem>
  private _total = 0;

  basic: Object;
  standard: Object;
  premium: Object;

  ngOnInit() {

    this.__categoryService.getCategoryByKey('basic').get()
      .then((value) => {
        this.basic = JSON.parse(value.data().data);
        if (!this.once) {
          this.categoryData = this.basic;
          this.processData(this.investor);
          this.once = true;
          this.onceChange.emit(this.once);
        }
      });
    this.__categoryService.getCategoryByKey('standard').get()
      .then((value) => {
        this.standard = JSON.parse(value.data().data);
      });
    this.__categoryService.getCategoryByKey('premium').get()
      .then((value) => {
        this.premium = JSON.parse(value.data().data);
      });
  }

  ngOnChanges(change) {
    // console.log("change123", change);
    if (change["investor"] && change["investor"].currentValue) {
      if (!change["investor"].previousValue) {
        this.processData(this.investor);
        // console.log("change123", "changing1");
      } else {
        if (JSON.stringify(change["investor"].previousValue) != JSON.stringify(change["investor"].currentValue)) {
          this.processData(this.investor);
          // console.log("change123", "changing2");
        }
      }
    }
  }

  categoryChanges(changes) {
    switch (changes) {
      case "basic":
        this.categoryData = this.basic;
        break;
      case "standard":
        this.categoryData = this.standard;
        break;
      case "premium":
        this.categoryData = this.premium;
        break;
      default:
        this.categoryData = this.basic;
        break;
    }
    this.categoryChange.emit(this.category);
    this.chart2.destroy();
    this.second_chart = this.gerenateChartData(this.investor.risk_category);
    this.chart3.destroy();
    this.third_chart = this.gerenateChartData(this.nextRiskCat(this.investor.risk_category))
    this.chart4.destroy();
    this.fourth_chart = this.gerenateChartData(this.new_risk_category);
  }

  gerenateChartData(riskCategory) {
    const values = this.categoryData[riskCategory].values;
    const chartdata = Object.keys(this.categoryData[riskCategory].values).map((item, index) => {
      return new DoughnutChartItem(item, values[item], this.assetGroups[index]["color"], 0);
    });
    return chartdata;
  }

  nextRiskCat(currentRisk) {
    switch (currentRisk) {
      case "conservative":
        return "conservative_plus"
      case "conservative_plus":
        return "moderate"
      case "moderate":
        return "moderate_plus"
      case "moderate_plus":
        return "aggressive"
      case "aggressive":
        return "higly_aggressive"
      case "higly_aggressive":
        return "higly_aggressive"
      default:
        return currentRisk
    }
  }

  processData(investor) {
    // this.investor = investor;
    // return;
    const assetAllocationGroups = groupBy(
      this.investor.assets,
      'asset_allocation_type',
    );

    this._total = this.chartData.reduce((total, item) => {
      return total + item.count;
    }, 0);

    this.chartData = availableGroupings.map((group) => {
      const assets = assetAllocationGroups[group.group] || [];

      const assetsTotal =
        assets
          .map((a) => parseInt(a.value) || 0)
          .reduce((val1, val2) => val1 + val2, 0) || 0;
      const assetsReturns =
        assets
          .map((a) => a.return_percentage)
          .reduce((val1, val2) => val1 + val2, 0) || 0;
      return new DoughnutChartItem(
        group.name,
        assetsTotal,
        group.color,
        assetsReturns,
      );
    });
    // this.new_risk_category = this.investor.risk_category;
    this.chart4.destroy();
    this.chart2.destroy();
    this.chart3.destroy();
    this.second_chart = this.gerenateChartData(this.investor.risk_category);
    this.third_chart = this.gerenateChartData(this.nextRiskCat(this.investor.risk_category))
    this.fourth_chart = this.gerenateChartData(this.new_risk_category);
    // this.investor.risk_category
    // console.log("cdd", this.chartData);
  }

  getTotalAssetsValue() {
    return this.investor.assets
      .map((a) => parseInt(a.value) || 0)
      .reduce((val1, val2) => val1 + val2, 0);
  }

  getTotalAssetsReturnsValue() {
    return this.investor.assets
      .map((a) => ((parseInt(a.value) || 0) * a.return_percentage) / 100.0)
      .reduce((val1, val2) => val1 + val2, 0);
  }

  getTotalAssetsReturnsPercentage() {
    return (
      (this.getTotalAssetsReturnsValue() / this.getTotalAssetsValue()) * 100
    );
  }

  getPercentageForItem(item) {
    if (!item) {
      return 0;
    }
    return Math.round((item.count / this._total) * 100) || 0;
  }

  changeRiskCategory(riskCategory) {
    console.log("change", riskCategory);
    this.chart4.destroy();
    this.fourth_chart = this.gerenateChartData(riskCategory);
    this.new_risk_categoryChange.emit(riskCategory);

    console.log("change", this.new_risk_category);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/hwcheckup/reports/breakdown/breakdown.component.ts